
import Verify from '../utils/verify'
import ChinaAddressV2Data from 'vux/src/datas/china_address_v2.json'

import API from '../api'
import qs from 'qs'

// 是否是H5渠道
let h5 = false

export default {
name: 'm-form',
mounted () {
this.$store.commit('updateProductId', this.$route.params.productId)
this.$store.commit('updateUserId', this.$route.params.userId)
// this.$store.commit('updateOrderOpenId', this.$route.params.openId)
document.title = '填写投保信息'
if (this.insuredIDNumber !== '') this.checkInsuredIDNumber()
if (this.$route.query.utmSource && this.$route.query.utmSource === 'h5') {
this.h5 = true
}
},
data () {
return {
ChinaAddressV2Data: ChinaAddressV2Data,
CAPTCHACountdown: 0,
IDNumberValue: true,
h5: h5,
showLogin: false,
channelCode: 2,
launchData: null,
url: '',
arrObj: null,
arrPara: null,
arr: null
}
},
computed: {
IDNumberTitle () {
if (this.$store.state.insured.IDNumberExpire === '9999-10-10') {
this.IDNumberValue = true
} else {
this.IDNumberValue = false
}
return '身份证有效期<span class="IDNumber-content">长期有效</span>'
},
CAPTCHALabel () {
if (this.CAPTCHACountdown === 0) {
return '获取'
}
return this.CAPTCHACountdown + '秒'
},
IDNumberExpire: {
get () {
return this.$store.state.insured.IDNumberExpire
},
set (value) {
this.$store.commit('updateIDNumberExpire', value)
}
},
limitDate () {
let d = {
startDate: '',
endDate: ''
}
const now = new Date()
const nowYear = now.getUTCFullYear()
const nowMonth = now.getUTCMonth()
const nowDate = now.getUTCDate()
const startDate = new Date(nowYear, nowMonth, nowDate)
let endDate = new Date(nowYear + 50, nowMonth, nowDate)
d.startDate = startDate.getFullYear() + '-' + ((startDate.getMonth() + 1) < 10 ? '0' : '') + (startDate.getMonth() + 1) + '-' + (startDate.getDate() < 10 ? '0' : '') + startDate.getDate()
d.endDate = endDate.getFullYear() + '-' + ((endDate.getMonth() + 1) < 10 ? '0' : '') + (endDate.getMonth() + 1) + '-' + (endDate.getDate() < 10 ? '0' : '') + endDate.getDate()
return d
},
holderPhoneNumber: {
get () {
return this.$store.state.holder.phoneNumber
},
set (value) {
this.$store.commit('updateHolderPhoneNumber', value.trim())
}
},
holderAddress: {
get () {
return this.$store.state.holder.address
},
set (value) {
this.$store.commit('updateHolderAddress', value.trim())
}
},
holderArea: {
get () {
return this.$store.state.holder.area
},
set (value) {
this.$store.commit('updateHolderArea', value)
// 更新保额
for (let i = this.$store.getters.insuranceAmountsByIDNumber.length - 1; i >= 0; i--) {
if (this.$store.getters.insuranceAmountsByIDNumber[i].value === this.$store.state.order.insuranceAmount &&
this.$store.getters.insuranceAmountsByIDNumber[i].accessable === false) {
this.$store.commit('updateOrderInsuranceAmount', this.$store.getters.insuranceAmountsByIDNumber[0].value)
break
}
}
}
},
holderEmail: {
get () {
return this.$store.state.holder.email
},
set (value) {
this.$store.commit('updateHolderEmail', value.trim())
}
},
holderCAPTCHA: {
get () {
return this.$store.state.holder.CAPTCHA
},
set (value) {
this.$store.commit('updateHolderCAPTCHA', value.trim())
}
},
insuredName: {
get () {
return this.$store.state.insured.name
},
set (value) {
this.$store.commit('updateInsuredName', value.trim())
}
},
insuredIDNumber: {
get () {
return this.$store.state.insured.IDNumber
},
set (value) {
this.$store.commit('updateInsuredIDNumber', value.trim().toUpperCase())
// 更新保额
for (let i = this.$store.getters.insuranceAmountsByIDNumber.length - 1; i >= 0; i--) {
if (this.$store.getters.insuranceAmountsByIDNumber[i].value === this.$store.state.order.insuranceAmount &&
this.$store.getters.insuranceAmountsByIDNumber[i].accessable === false) {
this.$store.commit('updateOrderInsuranceAmount', this.$store.getters.insuranceAmountsByIDNumber[0].value)
break
}
}
}
},
insuredValue: {
get () {
return this.$store.state.order.insuredValue
},
set (value) {
this.$store.commit('updateOrderInsuredValue', value)
}
},
insuranceAmountsByIDNumber () {
return this.$store.getters.insuranceAmountsByIDNumber
},
insuranceAmount: {
get () {
return this.$store.state.order.insuranceAmount
},
set (value) {
this.$store.commit('updateOrderInsuranceAmount', value)
}
},
paymentPeriodsByIDNumber () {
return this.$store.getters.paymentPeriodsByIDNumber
},
paymentPeriod: {
get () {
return this.$store.state.order.paymentPeriod
},
set (value) {
this.$store.commit('updateOrderPaymentPeriod', value)
}
},
number () {
if (this.$store.getters.computPaymentByIDNumber === null) {
return '105'
}
return this.$store.getters.computPaymentByIDNumber
},
orderInsurancePeriod: {
get () {
return this.$store.state.order.insurancePeriod
},
set (value) {
this.$store.commit('updateOrderInsurancePeriod', value)
}
},
insurancePeriods () {
return this.$store.getters.accessableInsurancePeriodsByIDNumber
},
paymentShowNull () {
return this.$store.state.order.paymentShowNull
},
occupationCode () {
return this.$store.state.insured.occupationCode
},
occupationName () {
return this.$store.state.insured.occupationName
}
},
methods: {
getQueryString (name) {
this.url = location.hash
this.arrObj = this.url.split('?')
this.arrPara = this.arrObj[1].split('&')
for (let i = 0; i < this.arrPara.length; i++) {
this.arr = this.arrPara[i].split('=')
if (this.arr[0] === name) {
if (this.arr != null) return decodeURIComponent(this.arr[1])
}
}
},
launchCommon () {
if (String(this.$store.state.order.userId) === '148198068433580000') {
this.channelCode = 1
} else if (this.h5 !== false) {
this.channelCode = 3
}
this.launchData = {anchorCode: 1, channelCode: this.channelCode, linkedProduct: '优爱宝定期寿险', utSource: this.getQueryString('hmsr'), phoneNumber: this.holderPhoneNumber, personName: this.insuredName, identityCard: this.insuredIDNumber, verifyCode: this.holderCAPTCHA}
console.log(this.launchData)
this.$http.post('/api/pageView/savePageViewRecord', qs.stringify(this.launchData)).then((response) => {
console.log(response)
})
},
submitOrder () {
if (this.checkInsuredName() &&
this.checkInsuredIDNumber() &&
this.checkIDNumberExpire() &&
this.checkHolderPhoneNumber() &&
this.checkHolderCAPTCHA() &&
this.checkHolderEmail() &&
this.checkHolderArea() &&
this.checkHolderAddress()) {
// 验证码
// if (this.$store.state.holder.realCAPTCHA !== this.$store.state.holder.CAPTCHA) {
//   this.$vux.toast.show({
//     type: 'text',
//     text: '客官，请填写正确的验证码',
//     position: 'top',
//     width: '20em'
//   })
//   return false
// }
// 提交表单
const data = {
'productCode': this.$store.state.order.productId, // 产品编码
'verificationCode': this.$store.state.holder.CAPTCHA, // 手机验证码
'policyInsuredList[0].coverageMultiples': this.$store.state.order.insuranceAmount + '00', // 保额
'policyInsuredList[0].insurePayWay': this.$store.state.order.paymentPeriod, // 交费期间
'policyInsuredList[0].durationPeriodType': (this.$store.state.order.insurancePeriod === '20' || this.$store.state.order.insurancePeriod === '30')
? '1' : '2', // 按年 按岁数
'policyInsuredList[0].durationPeriodValue': this.$store.state.order.insurancePeriod, // 保险期间
'innerCode': this.$store.state.order.userId, // innerCode
'policyHolder.holderName': this.insuredName, // 姓名
'policyHolder.holderPhone': this.holderPhoneNumber, // 手机
'policyHolder.holderIdType': '1', // ?
'policyHolder.holderIdNumber': this.insuredIDNumber, // 身份证
// 'policyHolder.holderNationality': 'CHN',
'policyHolder.holderArea': this.holderArea[0] + ',' + this.holderArea[1] + ',' + this.holderArea[2], // 地区
'policyHolder.holderAddress': this.holderAddress, // 地址
'policyHolder.holderEmail': this.holderEmail, // 邮箱
'policyHolder.holderIdEffective': this.$store.state.insured.IDNumberExpire, // 身份证有效期
'policyHolder.holderOccupation': this.$refs.occupation.getAttribute('code'), // 职业
'policyInsuredList[0].insuredOccupation': this.$refs.occupation.getAttribute('code'), // 职业
'policyInsuredList[0].holdInsRelation': '1',
'isNeedFillInsued': '1'
}

if (this.$route.query.activityCode) {
data.activityCode = this.$route.query.activityCode
}

if (this.$route.query.agentCode) {
data.agentCode = this.$route.query.agentCode
}

// 来源
if (this.$route.query.utm_source) {
data['orderSource'] = this.$route.query.utm_source
}
if (this.$route.query.utm_media) {
data['utmMedia'] = this.$route.query.utm_media
}
if (this.$route.query.utm_campaign) {
data['utmCampaign'] = this.$route.query.utm_campaign
}
if (this.$route.query.utm_term) {
data['utmTerm'] = this.$route.query.utm_term
}
if (this.$route.query.utm_content) {
data['utmContent'] = this.$route.query.utm_content
}

if (this.h5) {
data.merchantCode = this.$store.state.order.userId
for (let i in this.$route.query) {
data[i] = this.$route.query[i]
}
}
this.$store.commit('updateOccupationCode', this.$refs.occupation.getAttribute('code'))
this.$store.commit('updateOccupationName', this.$refs.occupation.innerText || this.$refs.occupation.textContent)
this.$vux.loading.show({
text: '正在提交'
})
let goInsurePolicy = '/api/illness/goInsurePolicy'
if (this.h5) goInsurePolicy = '/api/channel/illness/goInsurePolicy'
this.$http.post(goInsurePolicy, qs.stringify(data)).then((response) => {
this.$vux.loading.hide()
// 登录
if (response.data.code === 400) {
this.showLogin = true
return false
}
if (!response.data.unionOrderCode) {
this.$vux.toast.show({
type: 'text',
text: '客官，' + response.data.substring(6),
position: 'top',
width: '20em'
})
return false
}
this.$store.commit('updateOrderNumber', response.data.orderInfo[0].orderCode)
this.$store.commit('updateOrderUnionOrderCode', response.data.unionOrderCode)
this.$store.commit('updateOrderCountdownTimer', 1800)
this.$router.push({name: 'Order', params: {productId: this.$store.state.order.productId, userId: this.$store.state.order.userId, unionCode: this.$store.state.order.unionOrderCode}, query: this.$route.query})
})
}
},
changeIDNumberExpire () {
if (this.IDNumberValue) {
this.$store.commit('updateIDNumberExpire', '9999-10-10')
this.IDNumberValue = true
} else {
this.$store.commit('updateIDNumberExpire', '')
this.IDNumberValue = false
}
},
checkIDNumberExpire () {
if (this.IDNumberExpire === '') {
this.$vux.toast.show({
type: 'text',
text: '客官，请选择身份证有效期',
position: 'top',
width: '20em'
})
return false
}
return true
},
checkHolderPhoneNumber () {
if (this.holderPhoneNumber === '') {
this.$vux.toast.show({
type: 'text',
text: '客官，请输入手机号',
position: 'top',
width: '20em'
})
return false
}
if (!/^1[23456789]\d{9}$/.test(this.holderPhoneNumber)) {
this.$vux.toast.show({
type: 'text',
text: '客官，请正确输入手机号',
position: 'top',
width: '20em'
})
return false
}
return true
},
checkHolderCAPTCHA () {
if (this.holderCAPTCHA === '') {
this.$vux.toast.show({
type: 'text',
text: '客官，请输入验证码',
position: 'top',
width: '20em'
})
return false
}
if (!/^\d{4}$/.test(this.holderCAPTCHA)) {
this.$vux.toast.show({
type: 'text',
text: '客官，请正确输入验证码',
position: 'top',
width: '20em'
})
return false
}
if (this.checkHolderPhoneNumber()) {
this.launchCommon()
}
return true
},
sendCAPTCHA () {
if (this.checkHolderPhoneNumber()) {
const that = this
const utmSourcePhone = 'wechat170913'
const random = Math.random()
const needBusParam = this.holderPhoneNumber + '?utm_source_phone=' + utmSourcePhone + '&v=' + random
let sendMessageCode = '/api/common/sendMessageCodeNew/' + this.holderPhoneNumber + '?v=' + random + '&serviceName=' + window.hex_md5(needBusParam)
if (this.h5) sendMessageCode = '/api/channel/illness/sendMessageCodeNew/' + this.$route.params.productId + '/' + this.$route.params.userId + '/' + this.holderPhoneNumber
this.$http.get(sendMessageCode)
.then(response => {
if (response.data.statusCode == '000000') {
that.CAPTCHACountdown = 60
const CAPTCHATimer = setInterval(() => {
if (that.CAPTCHACountdown === 0) {
clearInterval(CAPTCHATimer)
} else {
that.CAPTCHACountdown--
}
}, 1000)
that.$store.commit('updateHolderRealCAPTCHA', response.data.statusCode)
} else {
this.$vux.toast.show({
type: 'text',
text: response.data.statusMsg,
position: 'top',
width: '20em'
})
}
})
}
},
checkHolderEmail () {
if (this.holderEmail === '') {
this.$vux.toast.show({
type: 'text',
text: '客官，请输入个人电子邮箱',
position: 'top',
width: '20em'
})
return false
}
if (!/^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/.test(this.holderEmail)) {
this.$vux.toast.show({
type: 'text',
text: '客官，请正确输入个人电子邮箱',
position: 'top',
width: '20em'
})
return false
}
return true
},
checkHolderArea () {
if (this.holderArea.length === 0) {
this.$vux.toast.show({
type: 'text',
text: '客官，请选择所在地区',
position: 'top',
width: '20em'
})
return false
}
return true
},
checkHolderAddress () {
if (this.holderAddress === '') {
this.$vux.toast.show({
type: 'text',
text: '客官，请输入详细地址',
position: 'top',
width: '20em'
})
return false
}
// 至少6个中文字符
// 求汉字数
let holderAddressChineseCount = 0
for (let i = 0; i < this.holderAddress.length; i++) {
if (/[\u4E00-\u9FA5]/.test(this.holderAddress[i])) {
holderAddressChineseCount++
}
}
if (holderAddressChineseCount < 6) {
this.$vux.toast.show({
type: 'text',
text: '客官，详细地址需大于等于6个汉字',
position: 'top',
width: '20em'
})
return false
}
if (this.holderAddress.match(/\ud83c[\udf00-\udfff]|\ud83d[\udc00-\ude4f]|\ud83d[\ude80-\udeff]/g) !== null) {
this.$vux.toast.show({
type: 'text',
text: '客官，请正确输入详细地址',
position: 'top',
width: '20em'
})
return false
}
return true
},
checkInsuredName () {
if (this.insuredName === '') {
this.$vux.toast.show({
type: 'text',
text: '客官，请输入投保姓名',
position: 'top',
width: '20em'
})
return false
}
// 2 - 8 个中文字符
if (!/^[\u4E00-\u9FA5]{2,12}$/.test(this.insuredName)) {
this.$vux.toast.show({
type: 'text',
text: '客官，请填写正确的投保姓名',
position: 'top',
width: '20em'
})
return false
}
return true
},
checkInsuredIDNumber () {
if (this.insuredIDNumber === '') {
this.$vux.toast.show({
type: 'text',
text: '客官，请填写身份证号',
position: 'top',
width: '20em'
})
this.$store.commit('updateOrderInsuranceAmount', '3')
this.$store.commit('updateOrderPaymentPeriod', '20')
this.$store.commit('updateOrderInsurancePeriod', '20')
this.$store.commit('updatePaymentShowNull', true)
return false
}
// 判断是否是合法的一代身份证或二代身份证
if (!Verify.verifyIDNumber(this.insuredIDNumber)) {
this.$vux.toast.show({
type: 'text',
text: '客官，请填写正确的身份证号',
position: 'top',
width: '20em'
})
this.$store.commit('updateOrderInsuranceAmount', '3')
this.$store.commit('updateOrderPaymentPeriod', '20')
this.$store.commit('updateOrderInsurancePeriod', '20')
this.$store.commit('updatePaymentShowNull', true)
this.$store.commit('updatePaymentByIDNumber', null)
return false
}
// 判断年龄
if (this.$store.getters.ageFromIDNumber > 60 || this.$store.getters.ageFromIDNumber < 18) {
this.$vux.toast.show({
type: 'text',
text: '客官，投保年龄18周岁-60周岁哦',
position: 'top',
width: '20em'
})
this.$store.commit('updateOrderInsuranceAmount', '3')
this.$store.commit('updateOrderPaymentPeriod', '20')
this.$store.commit('updateOrderInsurancePeriod', '20')
this.$store.commit('updatePaymentShowNull', false)
this.$store.commit('updatePaymentByIDNumber', null)
return false
}
// 更新保额
for (let i = this.$store.getters.insuranceAmountsByIDNumber.length - 1; i >= 0; i--) {
if (this.$store.getters.insuranceAmountsByIDNumber[i].value === this.$store.state.order.insuranceAmount &&
this.$store.getters.insuranceAmountsByIDNumber[i].accessable === false) {
this.$store.commit('updateOrderInsuranceAmount', this.$store.getters.insuranceAmountsByIDNumber[0].value)
break
}
}
// 更新保险期间
for (let i = 0; i <= this.$store.getters.accessableInsurancePeriodsByIDNumber.length - 1; i++) {
if (this.$store.getters.accessableInsurancePeriodsByIDNumber[i].value === this.$store.state.order.insurancePeriod &&
this.$store.getters.accessableInsurancePeriodsByIDNumber[i].accessable === false) {
this.$store.commit('updateOrderInsurancePeriod', '70')
// 如果20年可用，就20年
if (this.$store.getters.accessableInsurancePeriodsByIDNumber[0].accessable) {
this.$store.commit('updateOrderInsurancePeriod', this.$store.getters.accessableInsurancePeriodsByIDNumber[0].value)
} else if (this.$store.getters.accessableInsurancePeriodsByIDNumber[3].accessable) {
// 如果65可用，就65
this.$store.commit('updateOrderInsurancePeriod', this.$store.getters.accessableInsurancePeriodsByIDNumber[3].value)
} else {
// 否则就70，因为70始终可用
this.$store.commit('updateOrderInsurancePeriod', '70')
}
}
}
// 更新交费期间
for (let i = this.$store.getters.paymentPeriodsByIDNumber.length - 1; i >= 0; i--) {
if (this.$store.getters.paymentPeriodsByIDNumber[i].value === this.$store.state.order.paymentPeriod &&
this.$store.getters.paymentPeriodsByIDNumber[i].accessable === false) {
this.$store.commit('updateOrderPaymentPeriod', this.$store.getters.paymentPeriodsByIDNumber[i - 1].value)
}
}
const that = this
this.$store.commit('updatePaymentShowNull', true)
API.getPaymentByIDNumber(that)
return true
},
changePaymentPeriod () {
if (this.$store.getters.ageFromIDNumber === null) {
return
}
const that = this
API.getPaymentByIDNumber(that)
},
changeInsurancePeriod () {
if (this.$store.getters.ageFromIDNumber === null) {
return
}
const that = this
API.getPaymentByIDNumber(that)
},
closeLogin () {
this.showLogin = false
}
}
}



// WEBPACK FOOTER //
// ./src/components/Form.vue